import { render } from "./CollectionPanelCard.vue?vue&type=template&id=08f4401e&scoped=true"
import script from "./CollectionPanelCard.vue?vue&type=script&lang=js"
export * from "./CollectionPanelCard.vue?vue&type=script&lang=js"

import "@/Common/Styles/collectionCard.scss?vue&type=style&index=0&id=08f4401e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f4401e"]])

export default __exports__